module.exports = __webpack_public_path__ + "img/34_47.052eaeb7.png";